import React from 'react';
import { Box, Typography, Grid, Divider } from '@mui/material';

const TopSection = ({ selectedScenario, scenarios = [] }) => {
  const currentScenario = scenarios.find(scenario => scenario.id === selectedScenario) || {};
  
  // Parse the description to get customer info and goal
  const parseDescription = (description) => {
    if (!description) return { customerInfo: '', goal: '' };
    const [customerInfo, goal] = description.split('\n\n目標：');
    return { customerInfo: customerInfo.replace('客戶資料：\n', ''), goal };
  };

  const { customerInfo, goal } = parseDescription(currentScenario.description);

  return (
    <Box sx={{ 
      mb: 2,
      p: 2,
      bgcolor: '#fff',
      borderRadius: 4,
      boxShadow: '0 0 10px rgba(0,0,0,0.05)'
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
        <Box
          component="img"
          src={currentScenario.image}
          alt={currentScenario.name}
          sx={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            mr: 1.5,
            objectFit: 'cover'
          }}
        />
        <Box>
          <Typography variant="subtitle1" sx={{ 
            color: '#333',
            fontWeight: 500,
            lineHeight: 1.2
          }}>
            {currentScenario.title || ''}
          </Typography>
          
          {/* Display tags if available in a more compact way */}
          {currentScenario.tags && currentScenario.tags.length > 0 && (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
              {currentScenario.tags.map((tag, index) => (
                <Box 
                  key={index}
                  sx={{
                    bgcolor: '#e3f2fd',
                    color: '#1976d2',
                    px: 1,
                    py: 0.25,
                    borderRadius: 1,
                    fontSize: '0.7rem',
                    fontWeight: 500
                  }}
                >
                  {tag}
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Box>
      
      <Divider sx={{ my: 1 }} />
      
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Box>
            <Typography variant="body2" gutterBottom sx={{ 
              fontWeight: 600,
              color: '#1976d2',
              mb: 0.5
            }}>
              理解客戶背景
            </Typography>
            <Typography variant="caption" sx={{ color: '#666', display: 'block' }}>
              {customerInfo.split('\\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index < customerInfo.split('\\n').length - 1 && <br />}
                </React.Fragment>
              ))}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TopSection;
